const removeHTML = (string) => {
  return string.replaceAll(/<[^>]*>/g, "");
};

export default removeHTML;
